<template>
<v-dialog v-model="dialog" persistent width="800px" scrollable>
  <menu-add ref="menuAddDialog" @saveDialog="saveMenu"></menu-add>
  <v-card class="dialog_card">
        <v-card-title style="padding: 5px 5px 5px;font-size: 12pt !important;font-weight: bold;" class="dialog_title headline grey lighten-3" primary-title>
           <v-btn style="margin-left:10px;" class="btn_add" icon small @click="dialog = false">
              <v-icon>keyboard_backspace</v-icon>
            </v-btn>
           <div class="flex-grow-1"></div>
           Menu List
           <div class="flex-grow-1"></div>
          <v-btn icon light @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="padding:0;">
          <v-toolbar flat color="white" class="table_header" >
            <v-btn color="primary" class="action_btn"  depressed elevation="2"  small @click.stop="addMenu()">Add Menu</v-btn>                        
            <v-spacer></v-spacer>                        
          </v-toolbar>
          <v-simple-table height="300px">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">                            
                            Title
                          </th>
                          <th class="text-left">
                            Url
                          </th>
                          <th class="text-center">
                            Edit
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in menuList"
                          :key="index"
                        >
                          <td class="text-left">
                            <img class="v-icon" v-if="item.icon" :src="item.icon" height="30px"/>
                            {{ item.title }}
                          </td>
                          <td class="text-left">{{ item.url }}</td>
                          <td class="text-right">
                              <v-btn class="action_btn" color="primary" depressed elevation="2" rounded small @click.stop="editMenu(item, index)">Edit</v-btn>
                              <v-btn class="action_btn" color="error"   depressed elevation="2" rounded small @click.stop="deleteMenu(item, index)">Delete</v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
            
        </v-card-text>
  </v-card>
</v-dialog>
</template>  
<script>
import MenuAdd from "@/components/dockbuilder/DockMenuAdd";
export default {
  name: 'DockMenuList',  
  data() {
    return {
      dialog: false,
      menuList: []
    };
  },
  watch: {
    dialog (val) {
        val || this.close()
    },
  },
  components: {
    MenuAdd
  },
  computed: {
      user (){
        return this.$store.getters.user;
      }
  },
  methods: {
    clear(){
      this.menuList = [];
    },
    close() {
        this.$emit('closeDialog', this.menuList);
    },
    addMenu(){
      this.$refs.menuAddDialog.clear();
      this.$refs.menuAddDialog.dialog = true;
    },
    editMenu(menu, index){
      this.$refs.menuAddDialog.clear();
      this.$refs.menuAddDialog.dialog = true;
      this.$refs.menuAddDialog.dialogData = menu;
      this.$refs.menuAddDialog.dialogIndex = index;
    },
    deleteMenu(menu, index){
      this.menuList.splice(index, 1);
    },
    saveMenu(menu){
      if(!this.menuList)
        this.menuList = [];
      if(this.$refs.menuAddDialog.dialogIndex > -1)
        this.menuList[this.$refs.menuAddDialog.dialogIndex] = menu;
      else
        this.menuList.push(menu);
    }
  },
};
</script>

<style lang="scss" scoped>
.action_btn{
    margin-right: 5px;
  }
</style>